import { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { getGroups, getPagedDevicesAPI, getSitesOnSchedule } from "../../Api Methods/Api";
import { Await, useNavigate } from "react-router-dom";
import DevicesList from "../../components/GridList/DevicesList";
import DataManager from "../../hooks/DataManager";
import DeviceLoadingGrid from "../../components/GridList/DeviceLoadingGrid";
import classes from '../OfflineSites/offlineSites.module.css'
import Stats2 from "../../components/UI/Stats/Stats2";
import SearchBar from "../SearchView/Search/SearchBar";
import { filter } from "rxjs";
import ScheduleSitesList from "./scheduleListSites";
import { Button } from "primereact/button";
import SitesOnScheduleSearchBar from "./sitesOnScheduleSearchBar";
import { serviceActions } from "../../store/service-Slice";

const SitesOnSchedule = () => {

  const dataManager = new DataManager();
  const dispatch = useDispatch();
  const client = useSelector(state => state.auth.client);
  const token = useSelector(state => state.auth.token);
  const [searchTerm, setSearchTerm] = useState('');
  const apiData = {
      token,
      client
  }
  const [groups, setGroups] = useState([])
  const pageSize = 100;

  const service = useSelector(state => state.service);

  const cachedSites = useSelector(state => state.service.TempSchedulesTableData);
  const [sites, setSites] = useState(cachedSites);
  const [visibleDevices, setVisibleDevices] = useState(
    cachedSites.slice(0, pageSize)
  );
  const [isLoading, setIsLoading] = useState(() => {
      return !cachedSites || cachedSites.length === 0;
  }); 
  const [isLoadingStats, setIsLoadingStats] = useState(true)
  const [filteredSites, setFilteredSites] = useState([]);

  const [selectedGroupFilter, setSelectedGroupFilter] = useState(service.selectedGroupFilter)
  const [selectedFilter, setSelectedFilter] = useState(service.selectedFilter)
  const [sortBy, setSortBy] = useState(service.sortBy)
  const [page, setPage] = useState(service.page);
  const [wHm, setWHm] = useState(service.wHm)
  const [woHm, setWoHm] = useState(service.woHm)
  const [excludeLocks, setExcludeLocks] = useState(service.excludeLocks)
  const [excludePulse, setExcludePulse] = useState(service.excludePulse)
  const [portalSiteNameFilter, setPortalSiteNameFilter] = useState(service.portalSiteNameFilter)
  const [includes, setIncludes] = useState(service.includes)
  const [refresh, setRefresh] = useState(0)
  const [sitesWithHolidayMode, setSitesWithHolidayMode] = useState(service.sitesWithHolidayMode)
  const [daysFilter, setDaysFilter] = useState(service.daysFilter)
  const [fuzzySearch, setFuzzySearch] = useState(service.fuzzySearch)
  const [siteLocation, setSiteLocation] = useState(service.siteLocation)
  const [siteType, setSiteType] = useState(service.siteType)

  const dayToIndex = {
    Mondays: "0",
    Tuesdays: "1",
    Wednesdays: "2",
    Thursdays: "3",
    Fridays: "4",
    Saturdays: "5",
    Sundays: "6",
  };
  
  const HandleLoadMore = () => {
    console.log("called")
    const nextPage = page + 1;
    const start = page * pageSize;
    const end = nextPage * pageSize;
    const nextDevices = filteredSites.slice(start, end);

    if (nextDevices.length > 0) {
      setVisibleDevices(prev => [...prev, ...nextDevices]);
      setPage(nextPage);
    }
  };

  useEffect(() => {
    //setIsLoading(true)
    const getSites = async () => {
      const responseData = await getSitesOnSchedule(apiData, 0, dispatch)
      const raw = responseData.data[0]
      const parsed = raw.map(site => {
        let parsedDeviceDetails = {};
        let parsedDeviceExtraDetails = {};
        let parsedScheduledActions = {};

        try {
          parsedDeviceDetails = JSON.parse(site.deviceDetails || '{}');
        } catch (e) {
          console.warn(`Failed to parse deviceDetails for site ID ${site.id}`, e);
        }

        try {
          parsedDeviceExtraDetails = JSON.parse(site.deviceExtraDetails || '{}');
        } catch (e) {
          console.warn(`Failed to parse deviceExtraDetails for site ID ${site.id}`, e);
        }

        try {
          parsedScheduledActions = JSON.parse(site.scheduledActions || '{}');
        } catch (e) {
          console.warn(`Failed to parse scheduledActions for site ID ${site.id}`, e);
        }

        return {
          ...site,
          parsedDeviceDetails,
          parsedDeviceExtraDetails,
          parsedScheduledActions
        };
      });

      setSites(parsed);
      dispatch(serviceActions.setTempSchedulesSitesTableData(parsed));
      
      setIsLoading(false)
      setIsLoadingStats(false)
    };

    const GetGroups = async () => {
      try {
        const listOptions = await getGroups(apiData, dispatch);
        const groupNames = listOptions.map(group => group.name).sort((a, b) => a.localeCompare(b));
        console.log(groupNames)
        setGroups(groupNames || []);
      } catch (error) {
        setGroups([]);
      }
    };

    const getSitesWithHolidayMode = async () => {
      const responseData = await getSitesOnSchedule(apiData, 1, dispatch)
      const raw = responseData.data[0]

      console.log(raw)

      const parsed = raw.map(site => {
        let parsedDeviceDetails = {};
        let parsedDeviceExtraDetails = {};

        try {
          parsedDeviceDetails = JSON.parse(site.deviceDetails || '{}');
        } catch (e) {
          console.warn(`Failed to parse deviceDetails for site ID ${site.id}`, e);
        }

        try {
          parsedDeviceExtraDetails = JSON.parse(site.deviceExtraDetails || '{}');
        } catch (e) {
          console.warn(`Failed to parse deviceExtraDetails for site ID ${site.id}`, e);
        }

        return {
          ...site,
          parsedDeviceDetails,
          parsedDeviceExtraDetails,
        };

        
      });

      // console.log(parsed)
      // setSites(parsed);
      // setIsLoading(false)

      setSitesWithHolidayMode(parsed)
    }
  
    getSites();
    GetGroups();
    getSitesWithHolidayMode();
  }, [refresh]);

  useEffect(() => {
    if (!sites || sites.length === 0) return;

    let filtered;

    if (wHm) {
      filtered = [...sitesWithHolidayMode];
    } else if (woHm) {
      const holidayUuids = new Set(sitesWithHolidayMode.map(site => site.uuid));
      filtered = sites.filter(site => !holidayUuids.has(site.uuid));
    } else {
      filtered = [...sites];
    }

    if (selectedGroupFilter.length > 0) {
      filtered = filtered.filter(site => selectedGroupFilter.includes(site.name));
    }

    if (selectedFilter.length > 0) {
      if (selectedFilter.includes("Online")) {
        filtered = filtered.filter(site => site.online === "YES");
      }

      if (selectedFilter.includes("Offline")) {
        filtered = filtered.filter(site => site.online === "NO");
      }

      if (selectedFilter.includes("No portal site name")) {
        filtered = filtered.filter(site => site.tag == "");
      }
      if (selectedFilter.includes("Only active sites")) {
        filtered = filtered.filter(site => site.active == 1);
      }

      if (selectedFilter.includes("Only inactive sites")) {
        filtered = filtered.filter(site => site.active == 0);
      }
    }


    if (daysFilter.length > 0) {
      filtered = applyDayFilter(filtered, daysFilter, fuzzySearch);
    }

    if (searchTerm !== "" && (searchTerm !== dataManager.getItem('scheduleSitesSearchTerm'))){
      filtered = filtered.filter((item) =>
        Object.values(item)
          .some((value) => value?.toString().toLowerCase().includes(searchTerm.toLowerCase()))
      );
      dataManager.setItem('scheduleSitesSearchTerm', searchTerm)
    }

    if (portalSiteNameFilter !== ""){
      if (includes) {
        filtered = filtered.filter(item =>
          item?.tag?.toString().toLowerCase().includes(portalSiteNameFilter.toLowerCase())
        );
      } else {
        filtered = filtered.filter(item =>
          !item?.tag?.toString().toLowerCase().includes(portalSiteNameFilter.toLowerCase())
        );
      }
    }

    if (sortBy.length > 0) {
      const outputPinIds = {
        "Output 1 active": "5",
        "Output 2 active": "6",
        "Output 3 active": "13",
        "Output 4 active": "19",
      };

      const outputPinValues = Object.values(outputPinIds);

      if (sortBy.includes("Single pin sites")) {
        filtered = filtered.filter(site => {
          const details = site.parsedDeviceDetails;

          const activeOutputCount = outputPinValues.reduce((count, pinId) => {
            const pin = details[pinId];
            return pin?.active === 1 ? count + 1 : count;
          }, 0);

          return activeOutputCount === 1;
        });
      }

      if (sortBy.includes("Multi pin sites")) {
        filtered = filtered.filter(site => {
          const details = site.parsedDeviceDetails;

          const activeOutputCount = outputPinValues.reduce((count, pinId) => {
            const pin = details[pinId];
            return pin?.active === 1 ? count + 1 : count;
          }, 0);

          return activeOutputCount > 1;
        });
      }

      const outputFilters = sortBy.filter(item => outputPinIds[item]);
      const selectedPinIds = outputFilters.map(label => outputPinIds[label]);

      if (selectedPinIds.length > 0) {
        filtered = filtered.filter(site => {
          const details = site.parsedDeviceDetails;

          return outputPinValues.every(pinId => {
            const pin = details[pinId];
            const shouldBeActive = selectedPinIds.includes(pinId);
            return shouldBeActive
              ? pin?.active === 1
              : !pin || pin.active !== 1;
          });
        });
      }
    }

    console.log(siteLocation)

    if (siteLocation != null){
      console.log(siteLocation.code || null)
      filtered = filtered.filter(item =>
        item?.country_code?.includes(siteLocation.code)
      );
    }

    if (siteType != null){
      console.log(siteType.label || null)
      filtered = filtered.filter(item =>
        item?.site_type?.includes(siteType.label)
      );
    }


    if (excludePulse) {
      filtered = filtered.filter(site => {
        const details = site.parsedDeviceDetails;

        for (const pinId in details) {
          const pin = details[pinId];
          if (pin?.type === "PULSE" || pin?.type === "VIRTUAL_PULSE") {
            return false; // Exclude this site
          }
        }

        return true;
      });
    }

    setFilteredSites(filtered);
    setVisibleDevices(filtered.slice(0, pageSize));
    setPage(1);
  }, [sites, selectedGroupFilter, selectedFilter, searchTerm, sortBy, wHm, woHm, excludeLocks, excludePulse, portalSiteNameFilter, includes, daysFilter, fuzzySearch, siteType, siteLocation]);

  function applyDayFilter(devices, daysFilter, fuzzySearch) {
    console.log("here")
    console.log(devices)
    console.log(daysFilter)
    const dayIndexes = daysFilter.map(day => dayToIndex[day]);
  
    return devices
      .filter(site =>
        site.parsedScheduledActions?.some(schedule => {
          return dayIndexes.some(dayIndex =>
            fuzzySearch === 1
              ? schedule.days.includes(dayIndex)
              : schedule.days === `["${dayIndex}"]`
          );
        })
      )
      .map(site => {
        const matchingSchedules = site.parsedScheduledActions.filter(schedule =>
          dayIndexes.some(dayIndex =>
            fuzzySearch === 1
              ? schedule.days.includes(dayIndex)
              : schedule.days === `["${dayIndex}"]`
          )
        );
  
        return {
          ...site,
          parsedScheduledActions: matchingSchedules,
        };
      });
  }

  const HandleHolidayModeStatClick = () => {
    setWHm(true)
    setWoHm(false)
  }

  const HandleTotalSitesStatClick = () => {
    setSelectedFilter("")
    setSortBy([])
    setSelectedGroupFilter([])
    setWHm(false)
    setWoHm(false)
    setExcludeLocks(false)
    setExcludePulse(false)
  }
    
  return (
    <Await resolve={visibleDevices}>
      {(loadedSites) => {
        return (
          <>
            <div style={{ width: "100%"}}>
              <div style={{ display: "flex", flexDirection: "row", gap: "8px" }}>
                <Stats2
                  title={"Total sites on schedule"}
                  value={sites.length}
                  isLoadingStats={isLoadingStats}
                  isStatic={true}
                  allSitesFilter={HandleTotalSitesStatClick}
                />

                <Stats2
                  title={"with temporary schedules"}
                  value={sitesWithHolidayMode.length}
                  isLoadingStats={isLoadingStats}
                  isStatic={true}
                  setHolidayModeFilter={HandleHolidayModeStatClick}
                />
              </div>

              <br></br>
              {isLoading ? (
                <div style={{ display: "flex", width: "100%" }}>
                  <DeviceLoadingGrid
                    CardCount={
                      20
                    }
                  />
                </div>
              ) : (
                <>
                  <div className={classes.searchContainer}>
                    <SitesOnScheduleSearchBar
                        type="text"
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        showFilterButton={true}
                        groups={groups}
                        selectedGroupFilter={selectedGroupFilter}
                        setSelectedGroupFilter={setSelectedGroupFilter}
                        selectedFilter={selectedFilter}
                        setSelectedFilter={setSelectedFilter}
                        sortBy={sortBy}
                        setSortBy={setSortBy}
                        wHm={wHm}
                        setWHm={setWHm}
                        woHm={woHm}
                        setWoHm={setWoHm}
                        excludeLocks={excludeLocks}
                        setExcludeLocks={setExcludeLocks}
                        excludePulse={excludePulse}
                        setExcludePulse={setExcludePulse}
                        portalSiteNameFilter={portalSiteNameFilter}
                        setPortalSiteNameFilter={setPortalSiteNameFilter}
                        includes={includes}
                        setIncludes={setIncludes}
                        daysFilter={daysFilter}
                        setDaysFilter={setDaysFilter}
                        fuzzySearch={fuzzySearch}
                        setFuzzySearch={setFuzzySearch}
                        siteLocation={siteLocation}
                        setSiteLocation={setSiteLocation}
                        siteType={siteType}
                        setSiteType={setSiteType}
                        style={{
                            padding: "10px", 
                            width: "300px",    
                            fontSize: "14px",  
                            boxSizing: "border-box", 
                            borderRadius: "4px",
                        }}/>

                         <div>
                            <p>{filteredSites.length} results</p>
                        </div>
                    </div>

                    <ScheduleSitesList
                      devices={loadedSites}
                      refresh={refresh}
                      setRefresh={setRefresh}
                    />
                </>
              )}

              <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center', 
                textAlign: 'center',
                marginTop:"15px"
              }}>
                <Button style={{width: "30%"}}label="Load more" onClick={HandleLoadMore}/>
              </div>
            </div>
          </>
        )
      }}
    </Await>
  )
}

export default SitesOnSchedule;